/**
 * `useCan` — client-side RBAC for UX gating (show/hide/enable). NOT security:
 * real enforcement is Firestore rules + Cloud Functions. Re-renders on auth
 * change so a role change is reflected after the forced token refresh.
 */
import { useEffect, useState } from "react";
import type { Action, ResourceScope, ResourceType } from "@praesto/contracts";
import { useCore } from "./core";

export function useCan(
  action: Action,
  resource: ResourceType,
  scope?: ResourceScope,
): boolean {
  const core = useCore();
  const [, force] = useState(0);

  useEffect(() => core.auth.onAuthChange(() => force((n) => n + 1)), [core]);

  return core.rbac.can(action, resource, scope);
}
